import { render, staticRenderFns } from "./SeasonalPrices.vue?vue&type=template&id=5faaeecb&scoped=true"
import script from "./SeasonalPrices.vue?vue&type=script&lang=js"
export * from "./SeasonalPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faaeecb",
  null
  
)

export default component.exports